
  var _styles = {
  "double-card-container": {
    "width": "4.56rem",
    "height": "6.50667rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "marginTop": "0.24rem"
  },
  "double-card-image-view": {
    "borderRadius": "0.32rem 0.32rem 0 0",
    "width": "4.56rem",
    "height": "3.41333rem",
    "overflow": "hidden",
    "position": "relative"
  },
  "double-card-deal-title": {
    "margin": "0.24rem",
    "marginTop": "0.18667rem",
    "marginBottom": 0,
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,34)",
    "lineHeight": "0.50667rem",
    "fontWeight": "400"
  },
  "double-card-image": {
    "width": "4.56rem",
    "height": "3.41333rem"
  },
  "double-card-image-shadow": {
    "position": "absolute",
    "opacity": 0.6,
    "width": "4.56rem",
    "height": "0.64rem",
    "bottom": 0
  },
  "double-card-pos": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "position": "absolute",
    "bottom": "0.2rem",
    "left": "0.26667rem",
    "height": "0.32rem",
    "padding": "0.02667rem"
  },
  "double-card-pos-icon": {
    "width": "0.18667rem",
    "height": "0.21333rem",
    "marginBottom": "0.02667rem",
    "marginRight": "0.10667rem"
  },
  "double-card-pos-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.32rem",
    "fontWeight": "500"
  },
  "double-card-tag-field": {
    "marginTop": "0.08rem",
    "marginRight": "0.24rem",
    "marginBottom": "0.08rem",
    "marginLeft": "0.24rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "double-card-discount-tag": {
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.08rem",
    "backgroundColor": "rgb(255,39,39)",
    "marginRight": "0.08rem"
  },
  "double-card-discount-text": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.37333rem",
    "fontWeight": "600"
  },
  "double-card-sale-tag": {
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.08rem",
    "marginRight": "0.08rem"
  },
  "double-card-sale-text": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.37333rem",
    "fontWeight": "600"
  },
  "double-card-sale-tag-image": {
    "height": "0.42667rem",
    "marginRight": "0.08rem"
  },
  "double-card-bottom-field": {
    "display": "flex",
    "flexDirection": "row",
    "marginTop": "-0.08rem",
    "marginRight": "0.24rem",
    "marginBottom": "0.32rem",
    "marginLeft": "0.24rem",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "double-card-price-field": {
    "height": "1.2rem"
  },
  "double-card-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "double-card-price-icon": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.32rem",
    "fontWeight": "500",
    "marginBottom": "0.04rem"
  },
  "double-card-price-value": {
    "fontFamily": "MTfin-Regular2_0",
    "fontSize": "0.56rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.56rem",
    "fontWeight": "700"
  },
  "double-card-price-start": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(255,51,51)",
    "lineHeight": "0.34667rem",
    "fontWeight": "400",
    "marginLeft": "0.02667rem",
    "marginBottom": "0.05333rem"
  },
  "double-card-origin-price": {
    "marginTop": "-0.05333rem"
  },
  "double-card-btn": {
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "borderRadius": "0.4rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.8rem"
  },
  "double-card-btn-text": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.42667rem",
    "marginTop": "0.08rem",
    "fontWeight": "600"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-Regular2_0', 'url("https://s3plus.meituan.net/v1/mss_098f084b61e744a0ae960d755eaad45e/meishi-yingxiao/fonts/max-icon/MTfin-Regular2.0.ttf")');
    document.fonts.add(fontFace0);
    
  }
    


  module.exports = _styles;
  